<template>
  <div v-html="text"></div>
</template>

<script lang="babel">
import { defaultNullHtml } from "@/js/defaultNullHtml";
import { defaultTrueHtml } from "@/js/defaultTrueHtml";

export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    text() {
      if (this.attribute.isString) {
        return this.value;
      }

      if (Array.isArray(this.value)) {
        return this.value.join(", ");
      } else if (this.value === null) {
        return defaultNullHtml();
      } else if (typeof this.value === "boolean") {
        return this.value ? defaultTrueHtml() : defaultNullHtml();
      } else if (isNaN(this.value) && !isNaN(new Date(this.value))) {
        return (new Date(this.value)).toLocaleDateString([], this.getDateOptions(this.attribute.onlyDate));
      } else {
        return this.value;
      }
    }
  },
  methods: {
    getDateOptions(onlyDate) {
      let options = { day: '2-digit', month: '2-digit', year: 'numeric' };

      if (!onlyDate) {
        options.minute = '2-digit';
        options.hour = '2-digit';
      }

      return options;
    }
  }
}
</script>
